import { reservedWords } from '../numberPad/NumberPad.types'

export class NumericInputService {
  private setOfAllowedChars: Set<string> = new Set<string>()

  constructor(validCharacters: Array<string> = []) {
    validCharacters.forEach((c: string) => this.addValidCharacter(c))
  }

  addValidCharacterArray(characters: Array<string>): void {
    characters.forEach((c: string) => this.addValidCharacter(c))
  }

  addValidCharacter(char: string): void {
    if (reservedWords.indexOf(char) !== -1) {
      return
    }

    if (char.length > 1) {
      throw new Error(`addValidCharacter expected a char but received ${char}`)
    }
    this.setOfAllowedChars.add(char)
  }

  isValidKeyInput(key: string): boolean {
    return this.setOfAllowedChars.has(key)
  }
}
